export enum EnergyClassCode {
  APlusPlus = 'A++',
  APlus = 'A+',
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
}

export enum EnergyClassColor {
  A = '#00a54f',
  B = '#4cb848',
  C = '#bed630',
  D = '#fff101',
  E = '#fcb814',
  F = '#f36e21',
  G = '#b31217',
}

export enum OldEnergyClassCode {
  APlusPlusPlus = 'A+++',
  APlusPlus = 'A++',
  APlus = 'A+',
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}

export enum OldEnergyClassColor {
  APlusPlusPlus = '#009949',
  APlusPlus = '#4CB848',
  APlus = '#BED630',
  A = '#FFF101',
  B = '#FEB931',
  C = '#F97032',
  D = '#EE1D23',
}
